import { useEffect, useState } from "react";
import { useProgress } from "Contexts/ProgressContext";
import useSegment from "Hooks/useSegment";
import usePageData from "Hooks/usePageData";
import useSessionNavigate from "Hooks/useSessionNavigate";
import useBackgroundUpdate from "./useBackgroundUpdate";

// this hook handles all the global context/state updates whenever a new page is loaded:
// 1. gets and exposes the page data from config
// 2. updates the progress context to match the current page
// 3. updates the visual context 
// 4. on form submission, updates the progress context 
// 5. on form submission, navigates to the next page.

const usePageContextUpdate = () => {
  const [submitted, setSubmitted] = useState(false);

  const { currentPage, changePage, nextPage, updateProgress } = useProgress();
  const segment = useSegment();
  const { sessionNavigate } = useSessionNavigate();

  // get the main page data from config
  const {
    data, 
    backgroundStyle
  } = usePageData();

  // updates the progress context to track the current page
  useEffect(() => {
    if(currentPage === segment) return;
    changePage(segment);
  }, [segment, changePage, currentPage]);

  // updates the background style of visualcontext (is background inverted or not?)
  useBackgroundUpdate(backgroundStyle);

  useEffect(() => {
    if (!submitted) return;
    updateProgress(segment, true);
    if (nextPage !== null) sessionNavigate(`/form/${nextPage}`);

    return () => {
      setSubmitted(false);
    };
  }, [segment, submitted, updateProgress, nextPage, sessionNavigate]);

  return {
    currentPageData: data,
    setSubmitted
  }
}

export default usePageContextUpdate;